import { ClickAwayListener } from "@mui/material"
import { Box } from "@mui/system"
import { SmallButton } from "components/button/SmallButton.tsx"
import { useCallback } from "react"
import { DriverInfo, VehicleInfo } from "types/list-card-holder"

import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined"
import DoNotDisturbAltOutlinedIcon from "@mui/icons-material/DoNotDisturbAltOutlined"
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined"
import { useCardHolderContext } from "layouts/card-holder/context/useCardHolderContext.ts"

export const CardHolderMenu = ({
    driver,
}: {
    driver: DriverInfo | VehicleInfo
}) => {
    const {
        openActivateCardHolder,
        openDeactivateCardHolder,
        openUpdateCardHolder,
        driverSelected,
        setDriverSelected,
        setOpenUpdateCardHolder,
        setOpenDeactivateCardHolder,
        setOpenActivateCardHolder,
        isVehicle
    } = useCardHolderContext()

    const onClickAwayDriverMenu = useCallback(() => {
        if (
            !openActivateCardHolder &&
            !openDeactivateCardHolder &&
            !openUpdateCardHolder &&
            driver.id === driverSelected?.id
        ) {
            setDriverSelected(null)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openActivateCardHolder, openDeactivateCardHolder, openUpdateCardHolder])

    return (
        <ClickAwayListener onClickAway={onClickAwayDriverMenu}>
            <Box
                sx={{
                    position: "absolute",
                    top: driver.active ? "0" : null,
                    right: "0",
                    zIndex: 1500,
                    transform: "translate(100%, 0%)",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "0.25rem",
                }}
            >
                {driver.active ? (
                    <>
                        <SmallButton
                            startIcon={
                                <BorderColorOutlinedIcon color="secondary" />
                            }
                            onClick={() => setOpenUpdateCardHolder(true)}
                            data-cy={
                                isVehicle
                                    ? `vehicle__${driver.id}--modify`
                                    : `driver__${driver.id}--modify`
                            }
                        >
                            Modifier
                        </SmallButton>
                        <SmallButton
                            startIcon={
                                <DoNotDisturbAltOutlinedIcon color="error" />
                            }
                            onClick={() => setOpenDeactivateCardHolder(true)}
                            data-cy={
                                isVehicle
                                    ? `vehicle__${driver.id}--deactivate`
                                    : `driver__${driver.id}--deactivate`
                            }
                        >
                            Désactiver
                        </SmallButton>
                    </>
                ) : (
                    <SmallButton
                        startIcon={
                            <CheckCircleOutlinedIcon color="secondary" />
                        }
                        onClick={() => setOpenActivateCardHolder(true)}
                        data-cy={
                            isVehicle
                                ? `vehicle__${driver.id}--reactivate`
                                : `driver__${driver.id}--reactivate`
                        }
                    >
                        Réactiver
                    </SmallButton>
                )}
            </Box>
        </ClickAwayListener>
    )
}
